import { ClothingCategoryData } from "../../data/clothing/clothing-category.data";
import { ClothingThemeData } from "../../data/clothing-theme/clothing-theme.data";
import { ApiConfig } from "../../lib/request/api-config";

export const getClothingThemeApi: ApiConfig = {
  url: "/wx-api/clothing-theme",
  method: "get",
};

export interface ClothingThemeWithCategoriesDto extends ClothingThemeData {
  /**
   * 相关服装分类
   */
  categories: ClothingCategoryData[];
}
